import React, { Component } from 'react';

interface IProps {
    children: JSX.Element;
    renderErrElement?(errs: IErrInfo[]): JSX.Element;
    onError?(err: IErrInfo): void;
}

interface IState {
    hasError: boolean;
    errorStore: IErrInfo[];
}

interface IErrInfo {
    msg: string;
    stack: string;
}

/**
 * 组件异常捕获
 */
export class ErrorBoundary extends Component<IProps, IState> {
    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props: IProps) {
        super(props);
        this.state = {
            hasError: false,
            errorStore: [],
        };
    }

    public componentDidCatch(msg: Error, errInfo: { componentStack: string }) {
        const { onError } = this.props;
        const err = {
            msg: String(msg),
            stack: errInfo.componentStack,
        };
        this.setState({
            errorStore: [...this.state.errorStore, err],
        });
        if (typeof onError === 'function') {
            onError(err);
        }
    }

    public renderErrs() {
        const errors = [...this.state.errorStore];
        errors.reverse();
        return errors.map((err, idx) => {
            return <pre key={idx}>{JSON.stringify(err)}</pre>;
        });
    }

    public renderErrMsg() {
        const { hasError } = this.state;
        if (!hasError) {
            return null;
        }

        return this.props.renderErrElement ? this.props.renderErrElement(this.state.errorStore) : this.renderErrs();
    }

    public render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        return this.renderErrMsg();
    }
}
